export default "__VITE_ASSET__51e2143e__"